import CrewList from '../components/CrewList';
import ResponsiveLayout from '../components/layout/ResponsiveLayout';

const CrewSharedSessions = () => (
  <ResponsiveLayout>
    <CrewList />
  </ResponsiveLayout>
);

export default CrewSharedSessions;
